import React, { ReactNode } from 'react';

interface Props {
  row: number;
  rowSpan?: number;
  column: number;
  columnSpan?: number;
  className?: string;
  children?: ReactNode;
}

export const LineItemFullCell: React.FC<Props> = ({
  row,
  rowSpan = 1,
  column,
  columnSpan = 1,
  className,
  children
}) => (
  <div
    className={className}
    style={{ gridRow: `${row} / span ${rowSpan}`, gridColumn: `${column} / span ${columnSpan}` }}
  >
    {children}
  </div>
);
